import performance from "../schema/performance";

const url = "https://theyoungrevolution.de/api/performances/next";

export default async function fetchNextPerformance() {
  const parsed = await fetch(url);
  const content = await parsed.json();
  return await performance.parseAsync(content);
}
